<template>
  <q-page padding>
    <div class="row">
      <div class="row q-gutter-sm">
        <div class="row col-12 text-brand-5" @click="voltar()">
          <q-icon size="sm" name="arrow_back_ios" class="cursor" />
          <p class="text-h6 text-weight-bold text-brand-5 texto-titulo">
            Editar Produto: #{{ produtoId }}
          </p>
        </div>
      </div>
    </div>
    <div
      class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-md q-ml-sm container-inputs"
    >
      <div class="col-md-2 col-sm-5 col-xs-5">
        <div class="q-ml-sm texto-titulo-input">Unidade</div>
        <q-select
          v-model="recebeUnidade.unidade"
          :options="$store.state.org.todaUnidades"
          dense
          outlined
          option-label="nome"
          class="select"
        />
      </div>
    </div>
    <div class="q-mt-xl">
      <p class="text-h6 q-ml-md text-weight-bold text-brand-5 texto-titulo">
        Informações Base
      </p>
      <div
        class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-sm q-ml-sm container-inputs items-center"
      >
        <div class="col-md-2 col-xs-5 col-sm-5">
          <div class="q-ml-sm texto-titulo-input">Código</div>
          <q-input
            v-model="dados.produto_codigo"
            class="input"
            dense
            disable
            bg-color="brand-7"
            outlined
          />
        </div>
        <div class="col-md-2 col-xs-6 col-sm-6">
          <div class="q-ml-sm texto-titulo-input">Descrição</div>
          <q-input
            v-model="dados.produto_descricao"
            class="input"
            dense
            outlined
          />
        </div>
        <div class="col-md-1 col-xs-5 col-sm-5">
          <div class="q-ml-sm texto-titulo-input">Preço</div>
          <q-input v-model="dados.produto_preco" class="input" dense outlined />
        </div>
        <div class="col-md-2 col-sm-6 col-xs-6">
          <div class="q-ml-sm texto-titulo-input">
            Categoria<q-icon
              class="q-ml-sm icon"
              name="edit"
              size="20px"
              @click="!disable ? (editarCategoria = !editarCategoria) : ''"
            />
          </div>
          <q-input
            v-if="!editarCategoria"
            v-model="dados.categoria_codigo"
            dense
            outlined
            class="select"
            disable
            bg-color="brand-7"
          />
          <q-select
            v-if="editarCategoria"
            v-model="categoria"
            :options="categorias"
            dense
            outlined
            class="select"
          />
        </div>
        <div class="col-md-2 col-sm-6 col-xs-6">
          <div class="q-ml-sm texto-titulo-input">
            Grupo<q-icon
              class="q-ml-sm icon"
              name="edit"
              size="20px"
              @click="!disable ? (editarGrupo = !editarGrupo) : ''"
            />
          </div>
          <q-input
            v-if="!editarGrupo"
            v-model="dados.grupo_nome"
            dense
            outlined
            class="select"
            disable
            bg-color="brand-7"
          />
          <q-select
            v-if="editarGrupo"
            v-model="grupo"
            :options="grupos"
            dense
            outlined
            input-debounce="0"
            use-input
            @filter="filterGrupo"
            class="select"
          />
        </div>
        <div>
          <p></p>
          <q-btn
            label="Atualizar Infos Base"
            color="positive"
            no-caps
            icon="check_circle_outline"
            class="q-mt-xs btn"
            @click="atualizarInfosBase()"
          />
        </div>
      </div>
    </div>
    <div class="q-mt-xl">
      <p class="text-h6 q-ml-md text-weight-bold text-brand-5 texto-titulo">
        Informações Fiscais
      </p>
      <div
        class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-sm q-ml-sm container-inputs items-center"
      >
        <div class="col-md-2 col-xs-5 col-sm-5">
          <div class="q-ml-sm texto-titulo-input">NCM</div>
          <q-input v-model="dados.ncm" class="input" dense outlined />
        </div>
        <div class="col-md-2 col-xs-6 col-sm-6">
          <div class="q-ml-sm texto-titulo-input">CEST</div>
          <q-input v-model="dados.cest" class="input" dense outlined />
        </div>
        <div class="col-md-2 col-xs-5 col-sm-5">
          <div class="q-ml-sm texto-titulo-input">CFOP</div>
          <q-input v-model="dados.cfop" class="input" dense outlined />
        </div>
        <div class="col-md-2 col-xs-6 col-sm-6">
          <div class="q-ml-sm texto-titulo-input">ICMS</div>
          <q-input v-model="dados.icms" class="input" dense outlined />
        </div>
        <div class="col-md-2 col-xs-5 col-sm-5">
          <div class="q-ml-sm texto-titulo-input">PIS</div>
          <q-input v-model="dados.pis" class="input" dense outlined />
        </div>
        <div class="col-md-2 col-xs-6 col-sm-6">
          <div class="q-ml-sm texto-titulo-input">COFINS</div>
          <q-input v-model="dados.cofins" class="input" dense outlined />
        </div>
        <div>
          <p></p>
          <q-btn
            label="Atualizar Infos Fiscais"
            color="positive"
            no-caps
            icon="check_circle_outline"
            class="q-mt-xs btn"
            @click="atualizarInfosFiscais()"
          />
        </div>
      </div>
    </div>
    <div class="q-mt-xl">
      <p class="text-h6 q-ml-md text-weight-bold text-brand-5 texto-titulo">
        Controle de Estoque e Compra
      </p>
      <div
        class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-sm q-ml-sm container-inputs items-center"
      >
        <div class="col-md-2 col-xs-6 col-sm-6">
          <div class="q-ml-sm texto-titulo-input">Estoque Atual</div>
          <q-input
            v-model="dados.quantidade"
            disable
            bg-color="brand-7"
            class="input"
            dense
            outlined
          />
        </div>
        <div class="col-md-2 col-xs-5 col-sm-5">
          <div class="q-ml-sm texto-titulo-input">Fornecedor</div>
          <q-select
            v-model="dados.ultimo_fornecedor"
            :options="listaFornecedores"
            option-label="business_name"
            option-value="id"
            dense
            outlined
            class="select select-fornecedor"
            use-input
            input-debounce="300"
            @filter="filtrarFornecedores"
            clearable
          >
            <template v-slot:selected-item="scope">
              <div class="fornecedor-truncate">
                <q-tooltip>{{ scope.opt.business_name }}</q-tooltip>
                {{ scope.opt.business_name }}
              </div>
            </template>
            <template v-slot:option="scope">
              <q-item v-bind="scope.itemProps">
                <q-item-section>
                  <q-item-label>{{ scope.opt.business_name }}</q-item-label>
                  <q-item-label caption
                    >{{ scope.opt.fantasy_name }} -
                    {{ scope.opt.cnpj }}</q-item-label
                  >
                </q-item-section>
              </q-item>
            </template>
          </q-select>
        </div>
        <div class="col-md-2 col-xs-6 col-sm-6">
          <div class="q-ml-sm texto-titulo-input">Estoque Crítico</div>
          <q-input
            v-model="dados.estoque_minimo"
            class="input"
            dense
            outlined
          />
        </div>
        <div class="col-md-2 col-xs-5 col-sm-5">
          <div class="q-ml-sm texto-titulo-input">Ponto de Reposição</div>
          <q-input
            v-model="dados.ponto_reposicao"
            class="input"
            dense
            outlined
          />
        </div>
        <div class="col-md-2 col-xs-6 col-sm-6">
          <div class="q-ml-sm texto-titulo-input">Estoque Máximo</div>
          <q-input
            v-model="dados.estoque_maximo"
            class="input"
            dense
            outlined
          />
        </div>
        <div class="col-md-2 col-xs-5 col-sm-5">
          <div class="q-ml-sm texto-titulo-input">Endereço</div>
          <q-input
            v-model="dados.endereco_produto"
            class="input"
            dense
            outlined
          />
        </div>
        <div class="col-md-2 col-xs-6 col-sm-6">
          <div class="q-ml-sm texto-titulo-input">Controla Lote</div>
          <q-select
            v-model="dados.controla_lote"
            :options="optionsControlaLote"
            dense
            outlined
            class="select"
            map-options
          />
        </div>
        <div class="col-md-2 col-xs-5 col-sm-5">
          <div class="q-ml-sm texto-titulo-input">Conta Contábil</div>
          <q-input
            v-model="dados.conta_contabil"
            class="input"
            dense
            outlined
          />
        </div>
        <div class="col-md-2 col-xs-6 col-sm-6">
          <div class="q-ml-sm texto-titulo-input">Unidade Medida</div>
          <q-input
            v-model="dados.unidade_medida"
            class="input"
            dense
            outlined
          />
        </div>
        <div class="col-md-2 col-xs-5 col-sm-5">
          <div class="q-ml-sm texto-titulo-input">Desc Uni Medida</div>
          <q-input
            v-model="dados.unidade_medida_descricao"
            class="input"
            dense
            outlined
          />
        </div>
        <div class="col-md-2 col-xs-6 col-sm-6">
          <div class="q-ml-sm texto-titulo-input">Lead Time</div>
          <q-input v-model="dados.lead_time" class="input" dense outlined />
        </div>
        <div class="col-md-2 col-sm-5 col-xs-5">
          <div class="q-ml-sm texto-titulo-input">Produto de Contrato</div>
          <q-select
            v-model="dados.contrato_fornecedor"
            :options="optionsProdutoContrato"
            dense
            outlined
            class="select"
            map-options
          />
        </div>
        <div>
          <p></p>
          <q-btn
            label="Atualizar Infos de Compras"
            color="positive"
            no-caps
            icon="check_circle_outline"
            class="q-mt-xs btn"
            @click="atualizarInfosCompras()"
          />
        </div>
      </div>
    </div>
  </q-page>
</template>

<script>
import { onMounted, ref, watch } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import { useQuasar } from "quasar";

export default {
  setup() {
    const store = useStore();
    const route = useRoute();
    const quasar = useQuasar();
    const router = useRouter();

    let recebeUnidade = ref({
      unidade: store.state.org.unidadeData.nome,
      id: store.state.org.unidadeData.id,
    });
    const categoria = ref({
      label: "Categoria",
      value: "",
    });
    const grupo = ref({
      label: "",
      value: "",
    });
    const categorias = ref([]);
    const disable = ref(false);
    const grupos = ref([]);
    const produtoId = route.params.produtoId;
    let unidadeId = route.params.unidadeId;
    const dados = ref({ controla_lote: null, produto_codigo: null });
    const time = ref(null);
    let editarCategoria = ref(false);
    let editarGrupo = ref(false);
    const optionsControlaLote = [
      { label: "Não", value: 0 },
      { label: "Sim", value: 1 },
    ];
    const optionsProdutoContrato = [
      { label: "Não", value: 0 },
      { label: "Sim", value: 1 },
    ];
    const listaFornecedores = ref([]);

    const receberDetalhesProdutos = async () => {
      disable.value = true;
      try {
        const response = await store.dispatch(
          "catalogo/listarDetalhesProduto",
          {
            vendor_id: recebeUnidade.value.unidade.id
              ? recebeUnidade.value.unidade.id
              : unidadeId,
            product_id: produtoId,
          }
        );

        if (!response.data.data[0]) {
          quasar.notify({
            message: "Produto não consta no catalogo da unidade selecionada.",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          dados.value = { controla_lote: null, produto_codigo: null };
          return;
        }

        dados.value = response.data.data[0];

        if (dados.value.ult_fornecedor_id && dados.value.ult_fornecedor_nome) {
          const fornecedorAtual = {
            id: dados.value.ult_fornecedor_id,
            business_name: dados.value.ult_fornecedor_nome,
            fantasy_name: dados.value.ult_fornecedor_nome,
            cnpj: dados.value.ult_fornecedor_cnpj || "",
          };

          dados.value.ultimo_fornecedor = fornecedorAtual;

          if (
            !listaFornecedores.value.find((f) => f.id == fornecedorAtual.id)
          ) {
            listaFornecedores.value = [
              fornecedorAtual,
              ...listaFornecedores.value,
            ];
          }
        } else {
          dados.value.ultimo_fornecedor = null;
        }

        ajustarProduto();
        disable.value = false;
      } catch (error) {
        console.log("Erro em receberDetalhesProdutos:", error);
        disable.value = false;
        dados.value = [];
      }
    };

    const buscarFornecedorPorId = async (fornecedorId) => {
      try {
        const response = await store.dispatch("catalogo/filtrarFornecedores", {
          search: "",
        });

        const fornecedorEncontrado = response.data.results.data.find(
          (fornecedor) => fornecedor.id == fornecedorId
        );

        if (fornecedorEncontrado) {
          dados.value.ultimo_fornecedor = fornecedorEncontrado;

          if (!listaFornecedores.value.find((f) => f.id == fornecedorId)) {
            listaFornecedores.value = [
              fornecedorEncontrado,
              ...listaFornecedores.value,
            ];
          }
        } else {
          await buscarFornecedorPorIdDireto(fornecedorId);
        }
      } catch (error) {
        console.log("Erro ao buscar fornecedor:", error);
      }
    };

    const buscarFornecedorPorIdDireto = async (fornecedorId) => {
      try {
        const response = await store.dispatch("catalogo/filtrarFornecedores", {
          search: fornecedorId.toString(),
        });

        if (response.data.results.data.length > 0) {
          const fornecedorEncontrado =
            response.data.results.data.find(
              (fornecedor) => fornecedor.id == fornecedorId
            ) || response.data.results.data[0];

          dados.value.ultimo_fornecedor = fornecedorEncontrado;
          if (
            !listaFornecedores.value.find(
              (f) => f.id == fornecedorEncontrado.id
            )
          ) {
            listaFornecedores.value = [
              fornecedorEncontrado,
              ...listaFornecedores.value,
            ];
          }
        }
      } catch (error) {
        console.log("Erro ao buscar fornecedor por ID direto:", error);
      }
    };

    const listarCategorias = async () => {
      categorias.value = [];
      const response = await store.dispatch("catalogo/listarCategorias");

      let array = response.data.results.data;
      array.forEach((categoria) => {
        categorias.value.push({
          label: categoria.code,
          value: categoria.id,
        });
      });
    };

    const ajustarProduto = async () => {
      if (route.params.unidadeId == recebeUnidade.value.id) {
        return;
      }
      try {
        await store.dispatch("catalogo/ajustarProduto", {
          vendor_id: unidadeId,
          id: produtoId,
        });
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "O produto não tem relação com o vendor especificado.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        // Não limpar dados.value aqui para preservar os dados já carregados
      }
    };

    const listarGrupos = async (val) => {
      grupos.value = [];
      const response = await store.dispatch("catalogo/listarGrupos", {
        vendor_id:
          store.state.autenticacao.cliente.indexOf("staging-vale") != -1 ||
          store.state.autenticacao.cliente.indexOf("vale-epiexpress") != -1
            ? 218
            : recebeUnidade.value.unidade.id
            ? recebeUnidade.value.unidade.id
            : unidadeId,
        per_page: 1000,
        search: val,
      });

      let array = response.data.results.data;
      array.forEach((grupo) => {
        grupos.value.push({
          label: grupo.name,
          value: grupo.id,
        });
      });
    };

    const atualizarInfosBase = async () => {
      try {
        await store.dispatch("catalogo/atualizarInfosBase", {
          catalog_id: unidadeId,
          contract_product_description: dados.value.produto_descricao,
          price:
            dados.value.produto_preco == null
              ? undefined
              : dados.value.produto_preco,
          product_id: produtoId,
        });
        quasar.notify({
          message: "Informações atualizadas com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao atualizar informações",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const atualizarInfosBaseCategoria = async () => {
      try {
        await store.dispatch("catalogo/atualizarInfosBaseCategoria", {
          catalog_id: unidadeId,
          product_category_id: categoria.value.value,
          product_id: produtoId,
        });
        editarCategoria.value = false;
        receberDetalhesProdutos();
        quasar.notify({
          message: "Informações atualizadas com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao atualizar informações",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const atualizarInfosBaseGrupo = async () => {
      try {
        await store.dispatch("catalogo/atualizarInfosBaseGrupo", {
          catalog_id: unidadeId,
          product_group_id: grupo.value.value,
          product_id: produtoId,
        });
        editarGrupo.value = false;
        receberDetalhesProdutos();
      } catch (error) {
        console.log(error);
      }
    };

    const atualizarInfosFiscais = async () => {
      try {
        await store.dispatch("catalogo/atualizarInfosFiscais", {
          contract_id: unidadeId,
          product_id: produtoId,
          cfop: dados.value.cfop,
          cofins: dados.value.cofins,
          icms: dados.value.icms,
          pis: dados.value.pis,
        });
        quasar.notify({
          message: "Informações atualizadas com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        atualizarCestNcm();
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao atualizar informações",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const atualizarCestNcm = async () => {
      try {
        await store.dispatch("catalogo/atualizarCestNcm", {
          product_id: produtoId,
          cest: dados.value.cest,
          ncm: dados.value.ncm,
        });
        receberDetalhesProdutos();
      } catch (error) {
        console.log(error);
      }
    };

    const alterarControleLote = async () => {
      try {
        await store.dispatch("catalogo/alterarControleLote", {
          batch_control: dados.value.controla_lote.value,
          id: produtoId,
          vendor_id: unidadeId,
        });
        receberDetalhesProdutos();
      } catch (error) {
        console.log(error);
      }
    };

    const atualizarInfosCompras = async () => {
      if (
        dados.value.ponto_reposicao == "" ||
        dados.value.estoque_maximo == "" ||
        dados.value.estoque_minimo == ""
      ) {
        quasar.notify({
          message:
            "Erro, você precisa preencher ponto de reposição, estoque crítico e estoque máximo (o valor pode ser 0 (zero))!",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        await store.dispatch("catalogo/atualizarInfosCompras", {
          vendor_id: unidadeId,
          address: dados.value.endereco_produto,
          conta_contabil: dados.value.conta_contabil,
          id: produtoId,
          lead_time: dados.value.lead_time,
          max_amount: dados.value.estoque_maximo,
          measurement_unit: dados.value.unidade_medida,
          measurement_unit_description: dados.value.unidade_medida_descricao,
          minimal_amount: dados.value.estoque_minimo,
          replacement_amount: dados.value.ponto_reposicao,
          ultimo_fornecedor_id:
            dados.value.ultimo_fornecedor?.id || dados.value.ultimo_fornecedor,
          contrato_fornecedor:
            dados.value.contrato_fornecedor?.value ??
            dados.value.contrato_fornecedor,
        });

        quasar.notify({
          message: "Informações atualizadas com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao atualizar informações",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const filtrarFornecedores = async (val, update) => {
      if (val === "") {
        listaFornecedores.value = [];
        return;
      }
      const response = await store.dispatch("catalogo/filtrarFornecedores", {
        search: val,
      });
      listaFornecedores.value = response.data.results.data;
      update();
    };

    const voltar = () => {
      router.push({
        name: "catalogo-gestaocatalogo-todos-produtos",
        params: { unidadeId: route.params.unidadeId },
      });
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        recebeUnidade.value.unidade = store.state.org.unidadeData.nome;
        recebeUnidade.value.id = store.state.org.unidadeData.id;
        unidadeId = recebeUnidade.value.id;
        receberDetalhesProdutos();
      }
    );

    watch(
      () => categoria.value.value,
      () => {
        atualizarInfosBaseCategoria();
      }
    );

    watch(
      () => recebeUnidade.value,
      () => {
        receberDetalhesProdutos();
        listarGrupos();
      },
      { deep: true }
    );

    watch(
      () => grupo.value.value,
      () => {
        atualizarInfosBaseGrupo();
      }
    );

    watch(
      () => dados.value.controla_lote,
      () => {
        alterarControleLote();
      }
    );

    onMounted(receberDetalhesProdutos);
    onMounted(listarCategorias);
    onMounted(listarGrupos);

    return {
      recebeUnidade,
      receberDetalhesProdutos,
      buscarFornecedorPorId,
      buscarFornecedorPorIdDireto,
      unidadeId,
      dados,
      listarCategorias,
      categoria,
      categorias,
      editarCategoria,
      editarGrupo,
      grupo,
      grupos,
      listarGrupos,
      ajustarProduto,
      atualizarInfosBase,
      atualizarInfosBaseCategoria,
      atualizarInfosBaseGrupo,
      atualizarInfosFiscais,
      atualizarCestNcm,
      optionsControlaLote,
      optionsProdutoContrato,
      alterarControleLote,
      atualizarInfosCompras,
      voltar,
      produtoId,
      listaFornecedores,
      filtrarFornecedores,
      filterGrupo(val, update, abort) {
        clearTimeout(time.value);
        if (val.length < 1) {
          abort();
          return;
        }

        time.value = setTimeout(() => {
          listarGrupos(val);
        }, 2000);

        setTimeout(() => {
          update();
        }, 2500);
      },
    };
  },
};
</script>

<style scoped>
.cursor {
  cursor: pointer;
  margin-top: 3px;
}
.icon {
  cursor: pointer;
}
.fornecedor-truncate {
  max-width: calc(100% - 30px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.select-fornecedor {
  max-width: 100%;
}
@media (max-width: 600px) {
  .cursor {
    cursor: pointer;
    margin-top: 12px;
  }
  .texto-titulo {
    font-size: 14px;
    margin-top: 10px;
  }
  .btn {
    font-size: 12px;
    margin: 9px 0px 0px 0px;
  }
  .container-inputs {
    margin: 15px 0px 0px 0px;
  }
  .container-input-criar {
    margin: 7px 0px 0px 0px;
  }
  .texto-titulo-input {
    font-size: 12px;
    margin: 0px;
  }
  .input {
    font-size: 12px;
  }
  .select {
    font-size: 12px;
  }
}

.select-fornecedor {
  max-width: 100% !important;
  min-width: 0 !important;
  width: 100% !important;
}

.select-fornecedor .q-field__control {
  max-width: 100% !important;
  width: 100% !important;
}

.fornecedor-truncate {
  max-width: calc(100% - 50px) !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
}
</style>
